<template>
    <div>
        <b-card v-show="editMode===0">
            <b-row>
                <b-col sm="12" class="text-right">
                    <b-btn-group size="sm">
                        <b-button variant="white" class="button-icon-only mr-1" title="Обновить"
                                  @click="buttonRefreshClicked"
                        >
                            <i class="fa fa-sync"/>
                        </b-button>
                        <b-button v-show="userActionAccessArray['new']" variant="success" @click="buttonAddClicked">
                            <i class="fa fa-plus"/> Новая запись
                        </b-button>
                    </b-btn-group>
                </b-col>
            </b-row>
            <MyToolbar>
                <MyToolbarItem>
                    <b-input v-model="searchQuickFilter" @keyup.prevent.enter="buttonSearchClicked" maxlength="200"
                             size="sm" placeholder="Поиск..." ref="inputQuickFilter" @keyup.esc="searchQuickFilter=''"
                    />
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-button size="sm" variant="secondary" @click="buttonSearchClicked">Поиск</b-button>
                    <b-button size="sm" :variant="sortMode===0 ? 'secondary' : 'primary'" title="Расширенный поиск"
                              class="button-icon-only-normal ml-2"
                              @click="buttonAdvSearchShowClicked"
                    >
                        <i class="fas fa-cog"/>
                    </b-button>
                </MyToolbarItem>
            </MyToolbar>

            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>

            <b-table outlined hover head-variant="light" :fields="userListFields" :items="userList"
                     responsive="responsive" :no-local-sorting="true" sort-by="RES"
                     @row-clicked="tableRowClicked"
                     @sort-changed="sortChanged"
            >
            </b-table>
            <b-row>
                <b-col sm="6">
                    <b-pagination first-number last-number
                                  v-model="recordCurrentPageNumber" @input="loadResList"
                                  :total-rows="recordTotalNumber" :per-page="recordCountPerPage"
                    />
                </b-col>
                <b-col sm="6">
                    <div class="custom-items-per-page-div">
                        <label>Показать записей:</label>
                        <b-form-select id="input-records-per-page" size="sm" style="margin-left: 10px;width:65px"
                                       :options="recordCountPerPageArray" v-model="recordCountPerPage"
                                       @change="loadResList"
                        />
                    </div>
                </b-col>
            </b-row>

        </b-card>
        <b-card v-show="editMode===1" :title="addEditTitle">
            <b-alert :show="err" :variant="errVariant" class="mb-3">{{errText}}</b-alert>
            <b-form @submit.prevent="saveRecord" @reset.prevent="cancelRecord">
                <b-card no-body>
                    <b-tabs card v-model="activeTabIndex" @input="editTabChanged">
                        <b-tab title="Основные" class="pb-0">
                            <b-row>
                                <b-col md="12" v-if="userActionAccessCompany">
                                    <b-form-group label="РЭК" label-for="select-edit-company" class="required">
                                        <b-select id="select-edit-company" :options="editCompanies"
                                                  v-model="editCompanyUid" @change="loadResParams"
                                                  ref="selectEditCompany" :disabled="recordUid.length!==0"
                                        />

                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="РЭС" label-for="input-edit-res" class="required">
                                        <b-input id="input-edit-res" v-model="editRes" @keyup.esc="cancelRecord"
                                                 ref="inputEditRes" :disabled="getEditControlStatus" maxlength="100"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Склонение РЭС (#1)" label-for="input-edit-res-declension1"
                                                  class="required"
                                    >
                                        <b-input id="input-edit-res-declension1" v-model="editResDeclension1"
                                                 @keyup.esc="cancelRecord"
                                                 :disabled="getEditControlStatus" maxlength="50"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Данные руководителя РЭС" label-for="input-edit-head-info"
                                                  class="required"
                                    >
                                        <b-input id="input-edit-head-info" v-model="editHeadInfo"
                                                 @keyup.esc="cancelRecord"
                                                 :disabled="getEditControlStatus" maxlength="200"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Склонение данных руководителя РЭС (#1)"
                                                  label-for="input-edit-head-info-declension1" class="required"
                                    >
                                        <b-input id="input-edit-head-info-declension1" v-model="editHeadInfoDeclension1"
                                                 @keyup.esc="cancelRecord"
                                                 :disabled="getEditControlStatus" maxlength="200"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Адрес" label-for="input-edit-address" class="required">
                                        <b-input id="input-edit-address" v-model="editContactAddress" @keyup.esc="cancelRecord"
                                                 :disabled="getEditControlStatus" maxlength="200"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Телефоны" label-for="input-edit-phone-numbers" class="required">
                                        <b-input id="input-edit-phone-numbers" v-model="editContactPhoneNumbers"
                                                 @keyup.esc="cancelRecord" :disabled="getEditControlStatus" maxlength="50"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <b-form-group label="Примечание" label-for="textarea-edit-description">
                                        <b-textarea id="textarea-edit-description" v-model="editDescription" rows="2"
                                                    :disabled="getEditControlStatus" @keyup.esc="cancelRecord"
                                                    maxlength="500"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <b-form-group label="Статус записи" label-for="input-edit-record-status"
                                                  class="required">
                                        <b-select id="input-edit-record-status" :options="editRecordStatuses"
                                                  v-model="editRecordStatus"
                                                  :disabled="!userActionAccessArray['status']"
                                        />
                                    </b-form-group>
                                </b-col>
                            </b-row>

                        </b-tab>
                        <b-tab title="Кыргызча" style="min-height: 300px;" class="pb-0">
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="РЭС" label-for="input-edit-res-kyrgyz" class="required">
                                        <b-input id="input-edit-res-kyrgyz" v-model="editResKyrgyz"
                                                 @keyup.esc="cancelRecord"
                                                 ref="inputEditResKyrgyz" :disabled="getEditControlStatus"
                                                 maxlength="100"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Склонение РЭС (#1)"
                                                  label-for="input-edit-res-declension1-kyrgyz"
                                                  class="required"
                                    >
                                        <b-input id="input-edit-res-declension1-kyrgyz"
                                                 v-model="editResDeclension1Kyrgyz"
                                                 @keyup.esc="cancelRecord"
                                                 :disabled="getEditControlStatus" maxlength="50"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Данные руководителя РЭС"
                                                  label-for="input-edit-head-info-kyrgyz"
                                                  class="required"
                                    >
                                        <b-input id="input-edit-head-info-kyrgyz" v-model="editHeadInfoKyrgyz"
                                                 @keyup.esc="cancelRecord"
                                                 :disabled="getEditControlStatus" maxlength="200"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Склонение данных руководителя РЭС (#1)"
                                                  label-for="input-edit-head-info-declension1-kyrgyz" class="required"
                                    >
                                        <b-input id="input-edit-head-info-declension1-kyrgyz"
                                                 v-model="editHeadInfoDeclension1Kyrgyz" @keyup.esc="cancelRecord"
                                                 :disabled="getEditControlStatus" maxlength="200"
                                        />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab v-if="getUserAccessToOptions" title="Параметры" style="min-height: 300px;" class="pb-0">
                            <b-row>
                                <b-col md="12">
                                    <b-form-group :label="editResParamName1" label-for="input-edit-res-param1"
                                                  class="required">
                                        <b-input id="input-edit-res-param1" v-model="editResParamValue1"
                                                 ref="inputEditResParam1"
                                        />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-card>
                <div class="mt-5">
                    <b-button v-show="userActionAccessArray['edit']" type="submit" variant="primary">Сохранить
                    </b-button>
                    <b-button type="reset" variant="secondary" class="ml-2">
                        {{userActionAccessArray["edit"] ? 'Отмена': 'Закрыть'}}
                    </b-button>
                </div>

            </b-form>
        </b-card>

        <b-modal ref="modal-search" hide-footer centered title="Расширенный поиск" @hidden="modalHidden">
            <b-row>
                <b-col sm="12" v-if="userActionAccessCompany">
                    <b-form-group label="РЭК" label-for="input-AdvSearch-company">
                        <b-select id="input-AdvSearch-company" :options="searchCompanies"
                                  v-model="searchCompanyUid" autofocus
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Статус записи" label-for="input-AdvSearch-record-status">
                        <b-select id="input-AdvSearch-record-status" :options="searchRecordStatuses"
                                  v-model="searchRecordStatus"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="outline-danger" @click="buttonAdvSearchCancelClicked">Сбросить</b-button>
                <b-button variant="secondary" class="ml-2 float-right" @click="buttonAdvSearchCloseClicked">Закрыть
                </b-button>
                <b-button variant="primary" class="float-right" @click="buttonAdvSearchOkClicked">Поиск</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import MyToolbar from "@/view/components/MyToolbar";
    import MyToolbarItem from "@/view/components/MyToolbarItem";
    import axios from "axios";

    export default {
        name: "Res",
        components: {MyToolbar, MyToolbarItem},
        data() {
            return {
                userData: this.$store.getters.getUserData,
                recordCountPerPageArray: this.$store.getters.getRecordCountPerPageArray || [],
                recordCountPerPage: this.$store.getters.getRecordCountPerPage || 20,
                recordCurrentPageNumber: 1,
                recordTotalNumber: 0,

                activeTabIndex: 0,

                userActionAccessArray: [],
                userActionAccessCompany: 0,

                loadProcessing: 0,

                editMode: 0,
                addEditTitle: "",
                recordUid: "",
                recordVersion: "",

                err: false,
                errText: "",
                errVariant: "danger",

                searchQuickFilter: "",
                searchRecordStatus: -1,
                searchCompanyUid: 0,

                sortMode: 0,    //0-simple, 1-advanced
                sortBy: "RES",
                sortDesc: false,

                searchRecordStatuses: [
                    {'value': -1, 'text': "<все>"},
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                    {'value': 2, 'text': "заблокирован"},
                    {'value': 3, 'text': "на удаление"},
                    {'value': 4, 'text': "в архиве"},
                ],
                searchCompanies: [],

                userList: [],
                userListFields: [
                    {key: "RowNumber", label: "№", tdClass: "pointer"},
                    {key: "CompanyAlias", label: "РЭК", sortable: true, tdClass: "pointer"},
                    {key: "RES", label: "РЭС", sortable: true, tdClass: "pointer"},
                    {key: "RecordStatus", label: "Статус", sortable: true, tdClass: "pointer"},
                ],

                resParams: [],
                editCompanies: [],
                editRecordStatuses: [],
                recordStatusesForAdd: [
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                ],
                recordStatusesForEdit: [
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                    {'value': 2, 'text': "заблокирован"},
                    {'value': 3, 'text': "на удаление"},
                    {'value': 4, 'text': "в архиве"},
                ],

                editCompanyUid: 0,
                editRes: "",
                editContactAddress: "",
                editContactPhoneNumbers: "",
                editResDeclension1: "",
                editHeadInfo: "",
                editHeadInfoDeclension1: "",

                editResKyrgyz: "",
                editResDeclension1Kyrgyz: "",
                editHeadInfoKyrgyz: "",
                editHeadInfoDeclension1Kyrgyz: "",

                editDescription: "",
                editRecordStatus: -1,

                editResParamName1: "",
                editResParamValue1: "",

                currentRecordStatus: -1,
            }
        },
        created() {
            window.addEventListener('keydown', (e) => {
                if (e.key === 'Insert' && !e.ctrlKey && !e.altKey && !e.shiftKey) {
                    this.buttonAddClicked()
                }
            });

            this.userActionAccessArray = this.getUserActionAccessArray("RefsRES", this.userData.UserAccess)
            this.userActionAccessCompany = this.getUserDataAccess("RefsCompanies", this.userData.UserAccess)
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Справочники", route: "res"},
                {title: "РЭС"}
            ]);

            this.loadResList()
            if (!this.userActionAccessCompany) this.loadResParams()
            if (this.userData.UserGroupUid === 1) this.loadCompanies()

            //If not Admin - delete Company from the list
            if (this.userData.UserGroupUid !== 1) {
                let ind = this.userListFields.findIndex(item => item.key.toLowerCase() === "companyalias");
                if (ind >= 0)
                    this.userListFields.splice(ind, 1)
            }

            //If no access to archive
            if (!this.userActionAccessArray['archive']) {
                let ind = this.searchRecordStatuses.findIndex(item => item.value === 4);
                if (ind >= 0)
                    this.searchRecordStatuses.splice(ind, 1)
            }

            this.$nextTick(() => {
                this.$refs.inputQuickFilter.$el.focus()
            })
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            loadCompanies() {
                this.editCompanies = []
                this.searchCompanies = [{'value': 0, 'text': "<все>"}]

                axios.post("/ws/ws.svc/GetRefsCompaniesArray", {
                        'Session_UID': this.userData.Session_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.data.forEach(item => {
                                            this.editCompanies.push({'value': item.UID, 'text': item.Alias})
                                            this.searchCompanies.push({'value': item.UID, 'text': item.Alias})
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadResList() {
                this.errTextHide()

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRES", {
                        'Session_UID': this.userData.Session_UID,
                        'Page': this.recordCurrentPageNumber,
                        'RecordsPerPage': this.recordCountPerPage,
                        'SortField': this.sortBy,
                        'SortMode': (this.sortDesc ? 1 : 0),
                        'F_RES': this.searchQuickFilter,
                        'F_Company_UID': this.searchCompanyUid,
                        'F_RS': this.searchRecordStatus,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data) || this.isUndefined(resp.data.meta)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    this.userList = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(resp.data.meta.TotalRecordsAmount)) {
                                        this.recordTotalNumber = resp.data.meta.TotalRecordsAmount
                                    } else {
                                        this.errTextShow("Ошибка при получении общего кол-ва записей.", "danger", true)
                                    }
                                } else {
                                    this.recordTotalNumber = 0
                                    this.userList = []

                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            loadResParams() {
                this.errTextHide()
                this.resParams = []

                this.editResParamName1 = ""
                this.editResParamValue1 = ""

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESParamsArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.editCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    this.resParams = JSON.parse(resp.data.data)
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            sortChanged(e) {
                this.sortBy = e.sortBy
                this.sortDesc = e.sortDesc
                this.loadResList()
            },
            buttonSearchClicked() {
                this.recordCurrentPageNumber = 1
                this.loadResList()
            },
            buttonAdvSearchShowClicked() {
                this.$refs['modal-search'].show()
            },
            buttonAdvSearchOkClicked() {
                if (this.searchCompanyUid !== 0 || this.searchRecordStatus !== -1) {
                    this.sortMode = 1
                    this.searchQuickFilter = ""
                } else {
                    this.sortMode = 0
                }

                this.recordCurrentPageNumber = 1
                this.loadResList()
                this.$refs['modal-search'].hide()
            },
            buttonAdvSearchCancelClicked() {
                this.sortMode = 0
                this.searchCompanyUid = 0
                this.searchRecordStatus = -1
                this.recordCurrentPageNumber = 1
                this.$refs['modal-search'].hide()
                this.loadResList()
            },
            buttonAdvSearchCloseClicked() {
                this.$refs['modal-search'].hide()
            },

            buttonRefreshClicked() {
                this.loadResList()
            },
            buttonAddClicked() {
                this.errTextHide()
                this.activeTabIndex = 0
                this.recordUid = ""
                this.recordVersion = ""
                this.addEditTitle = "Добавление записи"
                this.editCompanyUid = 0
                this.editRes = ""
                this.editResDeclension1 = ""
                this.editHeadInfo = ""
                this.editHeadInfoDeclension1 = ""
                this.editResKyrgyz = ""
                this.editResDeclension1Kyrgyz = ""
                this.editHeadInfoKyrgyz = ""
                this.editHeadInfoDeclension1Kyrgyz = ""
                this.editDescription = ""
                this.editRecordStatus = 0
                this.currentRecordStatus = 0
                this.editRecordStatuses = this.recordStatusesForAdd

                this.editMode = 1

                this.editResParamValue1 = ""

                if (this.userActionAccessCompany) {
                    this.$nextTick(() => {
                        if (!this.isUndefined(this.$refs.selectEditCompany))
                            this.$refs.selectEditCompany.$el.focus()
                    })
                } else {
                    this.$nextTick(() => {
                        if (!this.isUndefined(this.$refs.inputEditRes))
                            this.$refs.inputEditRes.$el.focus()
                    })
                }
            },
            tableRowClicked(item) {
                this.errTextHide()
                this.activeTabIndex = 0
                this.recordUid = item.UID
                this.recordVersion = ""
                this.addEditTitle = ""
                this.editCompanyUid = 0
                this.editRes = ""
                this.editResDeclension1 = ""
                this.editHeadInfo = ""
                this.editHeadInfoDeclension1 = ""
                this.editResKyrgyz = ""
                this.editResDeclension1Kyrgyz = ""
                this.editHeadInfoKyrgyz = ""
                this.editHeadInfoDeclension1Kyrgyz = ""
                this.editContactAddress = ""
                this.editContactPhoneNumbers = ""
                this.editDescription = ""
                this.editRecordStatus = -1
                this.currentRecordStatus = -1

                this.editRecordStatuses = this.recordStatusesForEdit
                this.editResParamValue1 = ""

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESRecord", {
                        'Session_UID': this.userData.Session_UID,
                        'F_UID': this.recordUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    let result = (JSON.parse(resp.data.data))

                                    this.editCompanyUid = result.Company_UID ? parseInt(result.Company_UID.toString()) : 0
                                    this.editRes = result.RES.toString()
                                    this.editResDeclension1 = result.RESDeclension1.toString()
                                    this.editHeadInfo = result.HeadInfo.toString()
                                    this.editHeadInfoDeclension1 = result.HeadInfoDeclension1.toString()
                                    this.editContactAddress = result.ContactAddress.toString()
                                    this.editContactPhoneNumbers = result.ContactPhoneNumbers.toString()
                                    this.editResKyrgyz = result.KG_RES.toString()
                                    this.editResDeclension1Kyrgyz = result.KG_RESDeclension1.toString()
                                    this.editHeadInfoKyrgyz = result.KG_HeadInfo.toString()
                                    this.editHeadInfoDeclension1Kyrgyz = result.KG_HeadInfoDeclension1.toString()
                                    this.editDescription = result.Description.toString()
                                    this.editRecordStatus = parseInt(result.RS.toString())
                                    this.recordVersion = result.RVV.toString()

                                    this.currentRecordStatus = this.editRecordStatus

                                    if (!this.isUndefined(result.RESParams)) {
                                        this.resParams = result.RESParams
                                    }

                                    if (this.userActionAccessArray["edit"])
                                        this.addEditTitle = "Изменение записи: " + this.editRes
                                    else
                                        this.addEditTitle = "Просмотр записи: " + this.editRes
                                } else {
                                    this.errTextShow("Запись не найдена. Пожалуйста, обновите страницу.", "danger", true)
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.editMode = 1
                        this.loadProcessing--
                        this.$nextTick(() => {
                            this.$refs.inputEditRes.$el.focus()
                        })
                    })
                    .catch(err => {
                        this.editMode = 1
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            saveRecord() {
                this.errTextHide()

                if (this.userData.UserGroupUid === 1 && this.editCompanyUid === "") {
                    this.errTextShow("Выберите РЭК.", "info", true)
                    return
                }
                if (this.editRes.toString().trim() === "") {
                    this.errTextShow("Введите РЭС.", "info", true)
                    return
                }
                if (this.editResDeclension1.toString().trim() === "") {
                    this.errTextShow("Введите Склонение РЭС (#1).", "info", true)
                    return
                }
                if (this.editHeadInfo.toString().trim() === "") {
                    this.errTextShow("Введите Данные руководителя РЭС.", "info", true)
                    return
                }
                if (this.editHeadInfoDeclension1.toString().trim() === "") {
                    this.errTextShow("Введите Склонение данных руководителя РЭС (#1).", "info", true)
                    return
                }
                if (this.editContactAddress.toString().trim() === "") {
                    this.errTextShow("Введите Адрес.", "info", true)
                    return
                }
                if (this.editContactPhoneNumbers.toString().trim() === "") {
                    this.errTextShow("Введите Телефоны.", "info", true)
                    return
                }

                if (this.editResKyrgyz.toString().trim() === "") {
                    this.errTextShow("Введите РЭС - кыргызча.", "info", true)
                    return
                }
                if (this.editResDeclension1Kyrgyz.toString().trim() === "") {
                    this.errTextShow("Введите Склонение РЭС (#1) - кыргызча.", "info", true)
                    return
                }
                if (this.editHeadInfoKyrgyz.toString().trim() === "") {
                    this.errTextShow("Введите Данные руководителя РЭС - кыргызча.", "info", true)
                    return
                }
                if (this.editHeadInfoDeclension1Kyrgyz.toString().trim() === "") {
                    this.errTextShow("Введите Склонение данных руководителя РЭС (#1) - кыргызча.", "info", true)
                    return
                }

                if (this.editRecordStatus === -1) {
                    this.errTextShow("Выберите статус записи.", "info", true)
                    return
                }

                let saveResParams = []
                saveResParams.push({'Param_UID': 1, 'ParamValue': this.editResParamValue1})

                this.loadProcessing++
                axios.post("/ws/ws.svc/UpdateRefsRES", {
                        'Session_UID': this.userData.Session_UID,
                        'R_UID': this.recordUid,
                        'R_Company_UID': this.editCompanyUid,
                        'R_RES': this.editRes,
                        'R_RESDeclension1': this.editResDeclension1,
                        'R_HeadInfo': this.editHeadInfo,
                        'R_HeadInfoDeclension1': this.editHeadInfoDeclension1,
                        'R_KG_RES': this.editResKyrgyz,
                        'R_KG_RESDeclension1': this.editResDeclension1Kyrgyz,
                        'R_KG_HeadInfo': this.editHeadInfoKyrgyz,
                        'R_KG_HeadInfoDeclension1': this.editHeadInfoDeclension1Kyrgyz,
                        'R_ContactAddress': this.editContactAddress,
                        'R_ContactPhoneNumbers': this.editContactPhoneNumbers,
                        'R_Description': this.editDescription,
                        'R_RS': this.editRecordStatus,
                        'R_RV': this.recordVersion,
                        'R_RESParams': JSON.stringify(saveResParams),
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                this.loadResList()
                                this.editMode = 0
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
                this.loadProcessing--
            },
            cancelRecord() {
                this.errTextHide()
                this.editMode = 0
            },
            editTabChanged() {
                if (this.activeTabIndex === 0) {
                    if (this.userActionAccessCompany) {
                        this.$nextTick(() => {
                            if (!this.isUndefined(this.$refs.selectEditCompany)) {
                                this.$refs.selectEditCompany.$el.focus()
                            }
                        })
                    } else {
                        this.$nextTick(() => {
                            if (!this.isUndefined(this.$refs.inputEditRes))
                                this.$refs.inputEditRes.$el.focus()
                        })
                    }
                } else if (this.activeTabIndex === 2) {
                    this.$nextTick(() => {
                        if (!this.isUndefined(this.$refs.inputEditResParam1)) {
                            this.$refs.inputEditResParam1.$el.focus()
                        }
                    })
                }
            },
            modalHidden() {
                this.$nextTick(() => {
                    this.$refs.inputQuickFilter.$el.focus()
                })
            }
        },
        computed: {
            getEditControlStatus: function () {
                return (!this.userActionAccessArray["edit"] || this.currentRecordStatus > 0)
            },
            getUserAccessToOptions: function () {
                return (this.userActionAccessArray["show"] && this.userActionAccessArray["new"] && this.userActionAccessArray["edit"])
            }
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
            resParams: function () {
                this.editResParamValue1 = ""
                for (let i = 0; i < this.resParams.length; i++) {
                    if (this.resParams[i].Param_UID === 1) {
                        this.editResParamName1 = this.resParams[i].ParamName || ""
                        this.editResParamValue1 = this.resParams[i].ParamRefValue || ""
                    }
                }
            }
        }
    }
</script>

<style scoped>
    /deep/ .card-header {
        background-color: rgba(0, 0, 0, .03);
    }
</style>